import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import ExpandableContent, { DRIVER_TITLE_HEIGHT } from './expandable-content';
import { TRK_PRODUCT_LOCATION } from './lib/constants';
import styles from "./marketplace-product-card.module.css";
/**
 * Underlying scaffolding of the MarketplaceProductCard.
 * @private
 */
var BaseMarketplaceProductCardScaffold = function BaseMarketplaceProductCardScaffold(_ref) {
  var _ref$addToCompareNode = _ref.addToCompareNode,
    addToCompareNode = _ref$addToCompareNode === void 0 ? null : _ref$addToCompareNode,
    _ref$addToFavoritesNo = _ref.addToFavoritesNode,
    addToFavoritesNode = _ref$addToFavoritesNo === void 0 ? null : _ref$addToFavoritesNo,
    analytics = _ref.analytics,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$driversAndConten = _ref.driversAndContentNode,
    driversAndContentNode = _ref$driversAndConten === void 0 ? null : _ref$driversAndConten,
    _ref$hasAccordionOnMo = _ref.hasAccordionOnMobile,
    hasAccordionOnMobile = _ref$hasAccordionOnMo === void 0 ? false : _ref$hasAccordionOnMo,
    _ref$hasPreheaderBadg = _ref.hasPreheaderBadge,
    hasPreheaderBadge = _ref$hasPreheaderBadg === void 0 ? null : _ref$hasPreheaderBadg,
    _ref$headerNode = _ref.headerNode,
    headerNode = _ref$headerNode === void 0 ? null : _ref$headerNode,
    _ref$imageNode = _ref.imageNode,
    imageNode = _ref$imageNode === void 0 ? null : _ref$imageNode,
    _ref$matchScoreCtaNod = _ref.matchScoreCtaNode,
    matchScoreCtaNode = _ref$matchScoreCtaNod === void 0 ? null : _ref$matchScoreCtaNod,
    _ref$preheaderNode = _ref.preheaderNode,
    preheaderNode = _ref$preheaderNode === void 0 ? null : _ref$preheaderNode,
    _ref$bannerNode = _ref.bannerNode,
    bannerNode = _ref$bannerNode === void 0 ? null : _ref$bannerNode,
    _ref$categoryHeaderNo = _ref.categoryHeaderNode,
    categoryHeaderNode = _ref$categoryHeaderNo === void 0 ? null : _ref$categoryHeaderNo,
    trkSectionPosition = _ref.trkSectionPosition;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.productCardWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bannerContainer
  }, bannerNode), categoryHeaderNode, /*#__PURE__*/React.createElement("div", {
    className: classNames([className, styles.productCard, _defineProperty({}, styles.hasCcMatchScore, matchScoreCtaNode)])
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.preheaderContainer, _defineProperty({}, styles.preheaderContainerBadge, hasPreheaderBadge)])
  }, preheaderNode), /*#__PURE__*/React.createElement("div", {
    className: classNames([classes('display-none', 'display-initial--wide'), styles.ccMatchScoreContainer])
  }, matchScoreCtaNode), (addToCompareNode || addToFavoritesNode) && /*#__PURE__*/React.createElement("div", {
    className: styles.addToCompareWrapper
  }, addToFavoritesNode, !addToFavoritesNode && addToCompareNode), /*#__PURE__*/React.createElement("div", {
    className: styles.imageWrapper
  }, imageNode), /*#__PURE__*/React.createElement("div", {
    className: styles.headerContainer
  }, headerNode), hasAccordionOnMobile && /*#__PURE__*/React.createElement(ExpandableContent, {
    analytics: analytics,
    className: classes('display-none--wide'),
    contentCollapsedHeight: DRIVER_TITLE_HEIGHT,
    enableAnalytics: !!analytics,
    id: "QUICK-FACTS-AND-CONTENT",
    showLessText: "Hide Details",
    showMoreText: "See Details",
    trkSectionCategory: "".concat(TRK_PRODUCT_LOCATION, "__drivers"),
    trkSectionPosition: trkSectionPosition
  }, driversAndContentNode), /*#__PURE__*/React.createElement("div", {
    className: classNames([classes({
      'display-none': hasAccordionOnMobile,
      'display-initial--wide': hasAccordionOnMobile
    }), styles.driversAndContentWrapper])
  }, driversAndContentNode)));
};
if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
  var PropTypes = require('prop-types');
  BaseMarketplaceProductCardScaffold.propTypes = {
    analytics: PropTypes.object,
    className: PropTypes.string,
    driversAndContentNode: PropTypes.node,
    hasAccordionOnMobile: PropTypes.bool,
    hasPreheaderBadge: PropTypes.bool,
    headerNode: PropTypes.node,
    imageNode: PropTypes.node,
    matchScoreCtaNode: PropTypes.node,
    preheaderNode: PropTypes.node,
    bannerNode: PropTypes.node,
    categoryHeaderNode: PropTypes.node,
    trkSectionPosition: PropTypes.number
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
}

export default BaseMarketplaceProductCardScaffold;